import { GlobalErrorState } from "@/store/modules/globalError/state";

const getters = {
  globalError(state: GlobalErrorState) {
    return state.currentGlobalError;
  },
};

export default getters;
